import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Card, Col, Row, Form, Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../components/form/CustomSelect";
import { GET_MEMBER_LIST } from "../../graphql/queries/management";
import CustomFormGroup from "../../components/form/CustomFormGroup";
import SubmitButton from "../../components/common/SubmitButton";
import { WITHDRAW } from "../../graphql/mutations/transaction";
import TransactionListTable from "./components/TransactionListTable";

import { GET_MEMBER_TRANSACTION_LIST } from "../../graphql/queries/transaction";
import { useState } from "react";
import { TRANSACTION } from "../../constants/transaction";
import WithdrawRequestListTable from "./components/WithdrawRequestListTable";
import {
  onChangeAmountWithdraw,
  selectCustomerWithdraw,
} from "../transaction/redux/transactionSlice";
import { useTransactionRequestQuery } from "../../graphql/apollo/query-hooks";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/common/CustomErrorMessage";

const Withdraw = () => {
  const [key, setKey] = useState("approve");
  const dispatch = useDispatch();
  const transaction = useSelector((state) => state.transaction);
  const { withdraw } = transaction;
  const { data } = useQuery(GET_MEMBER_LIST);
  const { getTransactionRequests, refetchRequestList, loading } =
    useTransactionRequestQuery(TRANSACTION.WITHDRAW);

  const options = data?.memberList?.map((s) => ({
    value: s.id,
    label: `${s.nickname}(${s.memberId})`,
  }));

  const [
    fetchTransaction,
    { data: { getMemberTransactionList } = {}, refetch },
  ] = useLazyQuery(GET_MEMBER_TRANSACTION_LIST, {
    variables: { member: withdraw.member, action: "WITHDRAW" },
    onError(er) {
      showErrorToast(er.message);
    },
  });

  const handleChangeMember = (e) => {
    dispatch(selectCustomerWithdraw(e.value));
    fetchTransaction();
  };
  const handleChangeAmount = (e) =>
    dispatch(onChangeAmountWithdraw(parseInt(e.target.value)));

  const [withdrawBalance, { loading: loadingCreate }] = useMutation(WITHDRAW, {
    variables: {
      input: {
        amount: withdraw.amount,
        member: withdraw.member,
      },
    },
    refetchQueries: [{ query: GET_MEMBER_LIST }],
    onCompleted: (data) => {
      if (data) {
        refetch();
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    withdrawBalance();
  };

  return (
    <Card className="lao">
      <Card.Header>
        <Card.Title>
          <h3 className="p-1">ຖອນເງິນ</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
          <Tab eventKey="approve" title="ຢື່ນຢັນການຖອນເງິນຂອງລູກຄ້າ">
            <WithdrawRequestListTable
              data={getTransactionRequests}
              refetchRequestList={refetchRequestList}
              loading={loading}
            />
          </Tab>
          <Tab eventKey="topup" title="ຖອນເອງ">
            <Row>
              <Col lg={6}>
                <Form onSubmit={handleSubmit}>
                  <CustomSelect
                    options={options}
                    handleChange={handleChangeMember}
                    placeholder="-- ເລືອກລູກຄ້າ --"
                  />
                  <CustomFormGroup
                    label="ຈຳນວນເງິນ"
                    name="amount"
                    onChange={handleChangeAmount}
                    type="number"
                    value={withdraw.amount}
                    placeholder="ຈຳນວນເງິນ"
                    errorParam="amount"
                    required={true}
                  />
                  <div className="text-center">
                    <SubmitButton loading={loadingCreate} />
                  </div>
                </Form>
              </Col>
              <Col lg={6}>
                {withdraw.member ? (
                  <div className="transaction-list">
                    <h3>ປະຫວັດການຖອນເງິນ</h3>
                    <TransactionListTable data={getMemberTransactionList} />
                  </div>
                ) : null}
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default Withdraw;
